import React, { useState } from "react";
import { Icon, Panel, PlainButton } from "@culturehq/components";

import { useProfile, useQueryString } from "app/context";
import useUnseen from "app/context/useUnseen";
import { useDoor } from "app/hooks";
import { t, Trans } from "app/utils";

import FeedFilterAccordian from "components/common/FeedFilterAccordian";
import FilterAccordian from "components/common/FilterAccordian";
import Interests from "components/feed/Interests";
import FeedItemTypeFilter from "components/feed/FeedItemTypeFilter";
import AccessibleFocusOutlineElement from "components/common/AccessibleFocusOutlineElement";

const FeedLeftInfo = ({
  forYou, types, onFilterClear, onForYouFilterSelected, onInterestClicked, onTypeToggle
}) => {
  const { profile } = useProfile();
  const unseen = useUnseen("/");
  const { onClearQueryString } = useQueryString();
  const { open: openOnMobile, onToggle: onToggleOpenOnMobile } = useDoor(false);
  const [state, setState] = useState({
    unseenAllChecked: false,
    unseenForYouChecked: false
  });


  const onAll = () => {
    if (forYou) {
      setState({
        ...state,
        unseenAllChecked: true
      });
      onForYouFilterSelected(false);
    }
  };

  const onForYou = () => {
    if (!forYou) {
      setState({
        ...state,
        unseenForYouChecked: true
      });
      onForYouFilterSelected(true, true);
      onClearQueryString();
    }
  };

  const handleInterestClicked = interest => {
    setState({
      ...state,
      unseenAllChecked: true
    });
    onForYouFilterSelected(false);
    onInterestClicked(interest);
  };

  return (
    <>
      <div className="Filters__button-wrapper row clearfix hidden-lg">
        <div className="Filters__button col-xs-6 col-sm-6 col-md-6 col-lg-12">
          <img
            src={profile.organization.logo.originalUrl}
            alt={profile.organization.name}
          />
        </div>
      </div>

      <hr className="hidden-lg" />

      <div className="Filters__Container">
        <div className="Filters__Header">
          <h1><Trans>FEED</Trans></h1>
          <span className="with-icon">
            <div className="icon-container">
              <Icon icon="android-options" />
              {types?.length && (<span className="FeedFilterAccordian__badge">{types.length}</span>)}
            </div>
            <FeedFilterAccordian title={t("Filters")}>
              <FeedItemTypeFilter
                onTypeToggle={onTypeToggle}
                onFilterClear={onFilterClear}
                types={types}
              />
            </FeedFilterAccordian>
          </span>
        </div>
        <div className="row view-sec">
          <ul className="e_label">
            <li className={forYou ? "selected" : ""} onClick={() => onForYou()}>
              <AccessibleFocusOutlineElement tag="button" className="chq-btn">
                <Icon className="ac_icon" icon={forYou ? "star" : "ios-star-outline"} />
                <Trans>For you</Trans>
                {unseen.forYou && !forYou && !state.unseenForYouChecked && <div className="chq-nav--unseen" />}
              </AccessibleFocusOutlineElement>
            </li>
            <li className={!forYou ? "selected" : ""} onClick={() => onAll()}>
              <AccessibleFocusOutlineElement tag="button" className="chq-btn">
                <Icon className="ac_icon" icon={forYou ? "clock" : "clock-filled"} />
                <Trans>Explore</Trans>
                {unseen.allActivity && forYou && !state.unseenAllChecked && (
                  <div className="chq-nav--unseen" />
                )}
              </AccessibleFocusOutlineElement>
            </li>
          </ul>
          <div className="Filters__button">
            <PlainButton onClick={onToggleOpenOnMobile} className="button toggle-filters">
              <Icon icon="levels" />
              <Trans>Filters</Trans>
            </PlainButton>
          </div>
        </div>
        <div className="show-lg">
          <Panel className={openOnMobile ? "open" : "closed"}>
            <Panel.Body>
              <FilterAccordian initialOpen title={t("Item Type")}>
                <FeedItemTypeFilter
                  onTypeToggle={onTypeToggle}
                  onFilterClear={onFilterClear}
                  types={types}
                />
              </FilterAccordian>
            </Panel.Body>
          </Panel>
        </div>
      </div>
      <hr className="hidden-lg" />
      <Interests onInterestClicked={handleInterestClicked} />
    </>
  );
};

export default FeedLeftInfo;
